<template>
  <v-form
    v-if='data[personIndex]'>
    <v-card>
      <v-card-title
        class="headline grey lighten-2"
        primary-title>Adding New Family Member</v-card-title>

      <v-card-text>
        <v-text-field
          @focus="$event.target.select()"
          v-model="data[personIndex].name"
          label="Family member's first name"></v-text-field>

        <AgeQuestRel
          :data="data"
          :modifyIndex="personIndex"/>

        <RelationQuest
          :modifyData="data"
          :modifyIndex="personIndex"/>

        <GenderQuest
          :modifyData="data"
          :modifyIndex="personIndex"/>

        <div
          v-if='["niece/nephew", "paternal cousin", "maternal cousin", "grandchild", "great grandchild"].includes(data[personIndex].relationship)'>
          <span>Who is this person's father or mother?</span>

          <v-select
            placeholder="Parents of this person"
            v-model="data[personIndex].parents"
            :items="parentsList()"
            required></v-select>
        </div>

        <HalfSib
          v-if="data[personIndex].relationship !== 'child' && data[personIndex].relationship !== ''"
          :modifyData="data"
          :modifyIndex="personIndex"/>

        <DeathQuest
          :data="data"
          :modifyIndex="personIndex"/>

        <AddtionalQuestion  :data="dataModel"
        :modifyIndex="modifyIndex" />
        <span><v-icon
      slot="icon"
      color="blue"
      size="25"
    >
      info
    </v-icon>Please add any health conditions that this person has or has had that you are aware of. Provide as much information as you can, and don’t worry if there are some details missing.</span>
        <CondTest
          :modifyData="data"
          :modifyIndex="personIndex"/>

        <v-textarea
          v-model="data[personIndex].notes"
          outline
          name="input-7-4"
          label="Comments"
          value></v-textarea>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn
          color="red"
          text
          @click="cancel()">cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          @click="save()">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import CondTest from './CondTest';
import GenderQuest from './GenderQuest';
import RelationQuest from './RelationQuest';
import HalfSib from "./HalfSib";
import AgeQuestRel from "./AgeQuestRel";
import DeathQuest from "./DeathQuest"
import AddtionalQuestion from "./additonalQuest"
function genID() {
  var ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";

  var ID_LENGTH = 8;

  var generate = function() {
    var rtn = "";
    for (var i = 0; i < ID_LENGTH; i++) {
      rtn += ALPHABET.charAt(Math.floor(Math.random() * ALPHABET.length));
    }
    return rtn;
  };
  return generate();
}

export default {
  props: {
    data: Array
  },
  components: {
    AddtionalQuestion,
    CondTest,
    GenderQuest,
    AgeQuestRel,
    HalfSib,
    RelationQuest,
    DeathQuest
  },
  methods: {
    save () {
      // TODO: Need to remake this
      this.$emit('closeNewPersonModal')
    },
    cancel() {
      this.data.splice(this.personIndex, 1)
      this.$emit('cancelNewPersonModal')
    },
    ageText () {
      if (this.data[this.personIndex].isLiving) {
        return "What is this person's age?";
      } else {
        return "What was this person's age at passing?";
      }
    },
    parentsList () {
      let pList
      switch (this.data[this.personIndex].relationship) {
        case "grandchild":
          pList = this.data.filter(item => {
            return item.relationship === "child"
          }).map(function (obj) {
            return obj.name
          });
          return pList
        case "paternal cousin":
          pList = this.data.filter(item => {
            return item.relationship === "paternal uncle" || item.relationship === "paternal aunt"
          }).map(function (obj) {
            return obj.name
          });
          return pList
        case "maternal cousin":
          pList = this.data.filter(item => {
            return item.relationship === "maternal uncle" || item.relationship === "maternal aunt"
          }).map(function (obj) {
            return obj.name
          });
          return pList
        case "niece/nephew":
          pList = this.data.filter(item => {
            return item.relationship === "sibling"
          }).map(function (obj) {
            return obj.name
          });
          return pList
      }
    },
  },
  data () {
    return {
      fieldRules: [v => !!v || "this field is required"],
      ageRules: [v => (v && v >= 0) || 'Age must be larger or equal to 0'],
      personIndex: 0,
      personModel: {
        pid: "",
        relationship: "",
        name: "",
        gender: "",
        isLiving: true,
        age: 0,
        notes: "",
        conditions: [],
        dob: "",
        newGender: {
          legal: "",
          identity: "",
          assigned: ""
        },
      },
    };
  },
  mounted () {
    this.personIndex = this.data.length
    this.data.push(Object.assign({}, this.personModel))
    this.data[this.personIndex].pid = genID()
  },
  computed: {
    ...mapFields([
      'isAuthorized',
      'user',
      'snackBarshow',
      'snackBarType',
      'snackBarmessage',
    ]),
    ...mapFields("patientQuestion", [
      "snackbar",
      "errorText",
      "newGenderList",
      "formID"
    ]),
  }
}
</script>
